export enum MobileWebViewSurveyResultMessage {
  Success = 'Success',
  Failure = 'Failed',
}

export enum MobileWebViewSurveyMessage {
  TimeToVerify = 'TimeToVerify',
}

export enum IntakeSurveyState {
  InProgress = 'in-progress',
  Submitted = 'submitted',
}

export enum MedicalSurveyState {
  InProgress = 'in-progress',
  Submitted = 'submitted',
}

export enum SubscriptionType {
  Rx = 'rx',
  RxInsurance = 'rx-insurance',
  Orlistat = 'orlistat',
  CoachOnly = 'coachOnly',
}

export interface PayerInfoDataType {
  displayCarrierName: string
  carrier: string
  candidPayerId: string
  planId: string
  text?: string
  value?: string
}

export enum CustomerStatus {
  Pending = 'pending',
  Qualified = 'qualified',
  SystemDisqualified = 'systemDisqualified',
  ClinicianDisqualified = 'clinicianDisqualified',
  Canceled = 'canceled',
  AwaitingLabs = 'awaitingLabs',
  PrepurchaseComplete = 'prepurchaseComplete',
}

export interface RawSurveyData {
  currentPageNo?: number
  data: Record<string, any>
}

export interface BaseSurveySubmission {
  questionData: Questions
  rawSurveyData: RawSurveyData
}

export interface IntakeSurveySubmission extends BaseSurveySubmission {
  dqReason?: string
  orlistatDqReason?: string | null
  subscriptionType?: SubscriptionType | null
  shopifyId: string
  customerId?: string
  state: string
}

export interface Questions {
  [key: string]: QuestionData
}

interface QuestionData {
  title: string
  response: QuestionResponse
  position?: number
}

interface QuestionResponse {
  type: string
  value: any
  choices?: string[]
}

export enum DQReason {
  Over65 = 'Customer is over 65',
  Under18 = 'Customer is under 18',
  UnderMinimumBMI = 'BMI less than ',
  PregnantNursing = 'Pregnant / Nursing',
  StateIsNotSupported = 'State is not supported',
}

export type PhotonMedication = {
  id: string
  name: string
  strength?: string
  description?: string
  codes: {
    rxcui?: string
    SKU?: string
  }
  brandName?: string
  genericName?: string
}

export type PhotonAllergen = {
  id: string
  name: string
  rxcui?: string
}

export enum CustomerVerificationStatus {
  Submitted = 'submitted',
  Accepted = 'accepted',
  Rejected = 'rejected',
  NoPhoto = 'no-photo',
}

export type AddressType = {
  id?: string
  addressLine1: string
  addressLine2?: string
  city: string
  state: string
  zip: string
  updatedAt?: string
  createdAt?: string
}
